// extracted by mini-css-extract-plugin
export default {"root":"linkButton_root__umIus","small":"linkButton_small__RKfOY","medium":"linkButton_medium__jK0OK","large":"linkButton_large__tpOle"};